const POST_CREATED = 'POST_CREATED';
const POST_DELETED = 'POST_DELETED';
const POST_UPDATED = 'POST_UPDATED';
const USER_DELETED = 'USER_DELETED';
const NOTIFICATION_CREATED = 'NOTIFICATION_CREATED';
const USER_UNVERIFIIED = 'USER_UNVERIFIIED';
const USER_VERIFIIED = 'USER_VERIFIIED';
const PROFILE_UPDATE = 'PROFILE_UPDATE';
const SUCCESSFUL_ACCOUNT_ACTIVATION = 'SUCCESSFUL_ACCOUNT_ACTIVATION';
const ACCOUNT_PASSWORD_CHANGE = 'ACCOUNT_PASSWORD_CHANGE';
const ACCOUNT_DELETE_PASSWORD_MATCHED = 'ACCOUNT_DELETE_PASSWORD_MATCHED';
const FAILED_LOGIN = 'FAILED_LOGIN';
const SUCCESSFUL_LOGIN = 'SUCCESSFUL_LOGIN';
const PASSWORD_RECOVERY_REQUEST = 'PASSWORD_RECOVERY_REQUEST';
const SUCCESSFUL_PASSWORD_RECOVERY = 'SUCCESSFUL_PASSWORD_RECOVERY';
const SUCCESSFUL_REGISTRATION = 'SUCCESSFUL_REGISTRATION';

export const userAuditLogTypes = [
  USER_UNVERIFIIED,
  USER_VERIFIIED,
  PROFILE_UPDATE,
  SUCCESSFUL_ACCOUNT_ACTIVATION,
  ACCOUNT_PASSWORD_CHANGE,
  ACCOUNT_DELETE_PASSWORD_MATCHED,
  FAILED_LOGIN,
  SUCCESSFUL_LOGIN,
  PASSWORD_RECOVERY_REQUEST,
  SUCCESSFUL_PASSWORD_RECOVERY,
  SUCCESSFUL_REGISTRATION,
];

export const adminAuditLogTypes = [
  POST_CREATED,
  POST_DELETED,
  POST_UPDATED,
  USER_DELETED,
  NOTIFICATION_CREATED,
  USER_UNVERIFIIED,
  USER_VERIFIIED,
  PROFILE_UPDATE,
  SUCCESSFUL_ACCOUNT_ACTIVATION,
  ACCOUNT_PASSWORD_CHANGE,
  FAILED_LOGIN,
  SUCCESSFUL_LOGIN,
  PASSWORD_RECOVERY_REQUEST,
  SUCCESSFUL_PASSWORD_RECOVERY,
  SUCCESSFUL_REGISTRATION,
];
